<template>
  <div v-loading.body="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
      <template slot="header">
        <el-tabs v-model="queryParams.isOnsale" @tab-click="handleFilter">
          <el-tab-pane label="所有商品" name="-1" />
          <el-tab-pane label="未审核的商品" name="0" />
          <el-tab-pane label="审核通过的商品" name="1" />
          <el-tab-pane label="审核失败的商品" name="2" />
        </el-tabs>

        <el-row :gutter="10" class="filter-container">
          <el-col :xs="24" :sm="6">
            <el-input v-model="queryParams.goodsName" class="filter-item" placeholder="商品名称" />
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-input v-model="queryParams.shopName" class="filter-item" placeholder="商家名称" />
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
            <el-button v-if="queryParams.storeId" class="filter-item" style="margin-left: 10px;" type="danger" icon="el-icon-edit" @click="handleCreate">增加商品</el-button>
          </el-col>
        </el-row>
      </template>

      <el-table v-sticky-header stripe fit highlight-current-row :data="list" header-cell-class-name="table-header-cell">
        <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell">
          <template slot-scope="scope">
            <span>{{ (scope.$index + 1) + (queryParams.page - 1) * queryParams.limit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商家名称" prop="shortName" width="150" class-name="name-col" />
        <el-table-column label="商品名称" prop="productName" min-width="150" class-name="name-col" />
        <el-table-column label="商品图片" prop="cover" width="100" class-name="image-col">
          <template slot-scope="{row}">
            <el-image :src="row.cover" :preview-src-list="[row.cover]" lazy />
          </template>
        </el-table-column>
        <el-table-column label="价格类型" width="95" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="row.priceType === 2" type="success" effect="dark" size="medium">现金+积分</el-tag>
            <el-tag v-else-if="row.priceType === 1" type="info" effect="dark" size="medium">纯积分</el-tag>
            <el-tag v-else effect="dark" size="medium">纯现金</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="零售价" prop="retailPrice" width="80" align="right">
          <template slot-scope="{row}">{{ row.retailPrice | filterPrice }}</template>
        </el-table-column>
        <el-table-column label="会员价" width="100">
          <template slot-scope="{row}">
            <div v-if="row.priceType === 0" class="space-nowrap"><span>现金：</span><span>{{ row.retailPrice | filterPrice }}</span></div>
            <div v-else-if="row.priceType === 2" class="mb-5 space-nowrap"><span>现金：</span><span>{{ row.pointPrice | filterPrice }}</span></div>
            <div v-if="row.priceType !== 0" class="space-nowrap"><span>积分：</span><span>{{ row.point | filterPrice }}</span></div>
          </template>
        </el-table-column>
        <el-table-column label="库存" prop="quantity" width="80" align="right" />
        <el-table-column label="上架状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.isOnsale | saleType" size="medium">{{ row.isOnsale | saleText }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="120" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.status | checkType" effect="dark">{{ row.status | checkText }}</el-tag>
            <el-tooltip v-if="row.status === 2 && row.reason" :content="row.reason" placement="bottom" effect="light">
              <i class="tool-tip-icon el-icon-warning-outline" />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" width="80" fixed="right">
          <template slot-scope="{row}">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                操作<i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :disabled="row.status !== 0" @click.native.stop="handleApprove(row)"><i class="el-icon-check" /> 商品审核</el-dropdown-item>
                <el-dropdown-item divided :disabled="row.isOnsale === 1 || row.status !== 1" @click.native.stop="handleOnsale(row)"><i class="el-icon-upload2" /> 商品上架</el-dropdown-item>
                <el-dropdown-item :disabled="row.isOnsale === 0" @click.native.stop="handleDelist(row)"><i class="el-icon-download" /> 商品下架</el-dropdown-item>
                <el-dropdown-item divided @click.native.stop="handleEdit(row)"><i class="el-icon-edit" /> 编辑商品</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchData" />
    </el-card>

    <el-dialog
      v-loading="approveLoading"
      :title="dialogTitle"
      width="80%"
      top="5vh"
      destroy-on-close
      custom-class="dialog-scrollbar"
      :visible.sync="dialogVisible"
      :fullscreen="device==='mobile'"
    >
      <product-detail :store-id="selectedStoreId" :product-id="selectedGoodsId" />
      <template v-slot:footer>
        <el-button style="margin-right:10px" @click.stop="dialogVisible = false">取 消</el-button>
        <div v-if="isApprove">
          <el-popover v-model="approveVisible" title="审核不通过" placement="top" @hide="approveMessage = ''">
            <p><el-input v-model="approveMessage" placeholder="请输入不通过的理由" clearable /></p>
            <div class="flex align-center just-end">
              <el-button type="text" size="medium" @click.stop="approveVisible = false">取消</el-button>
              <el-button type="primary" @click.stop="onApproved(2)">确定</el-button>
            </div>
            <el-button slot="reference" type="info">不通过</el-button>
          </el-popover>
          <el-button type="primary" style="margin-left:10px" @click.stop="onApproved(1)">审核通过</el-button>
        </div>
        <el-button v-else-if="putOnsale" type="primary" @click.stop="onSale(1)">商品上架</el-button>
        <el-button v-else type="primary" @click.stop="onSale(0)">商品下架</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getGoods, approveGoods, putGoodOnsale } from '@/api/store'
import { StickyHeader } from '@cell-x/el-table-sticky'
import { mapState } from 'vuex'

export default {
  name: 'StoreGoodList',
  components: {
    Pagination: () => import('@/components/Pagination'),
    ProductDetail: () => import('./review')
  },
  directives: {
    StickyHeader: new StickyHeader({ offsetTop: 0, offsetBottom: 0 }).init()
  },
  filters: {
    saleType(index) {
      const tag = ['info', 'success']
      return tag[index]
    },
    saleText(index) {
      const tag = ['下架', '已上架']
      return tag[index]
    },
    checkType(index) {
      const tag = ['', 'success', 'info']
      return tag[index]
    },
    checkText(index) {
      const tag = ['未审核', '审核通过', '审核失败']
      return tag[index]
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      queryParams: {
        goodsName: '',
        shopName: '',
        isOnsale: '-1',
        storeId: '',
        page: 1,
        limit: 20
      },
      isApprove: false,
      putOnsale: false,
      dialogTitle: '商品审核',
      dialogVisible: false,
      approveVisible: false,
      approveMessage: '',
      approveLoading: false,
      onsaleVisible: false,
      selectedGoodsId: '',
      selectedStoreId: ''
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device
    })
  },
  created() {
    this.queryParams.storeId = this.$route.query.storeId || ''
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      const params = Object.assign({}, this.queryParams, {
        isOnsale: this.queryParams.isOnsale === '-1' ? undefined : this.queryParams.isOnsale
      })
      getGoods(params).then(response => {
        this.total = response.total
        this.$util.delay().then(() => {
          this.list = response.records
          this.loading = false
        })
      }).catch(() => {
        this.loading = false
      })
    },
    handleFilter() {
      this.queryParams.page = 1
      this.fetchData()
    },
    handleCreate() {
      this.$router.push({ path: `/store/goods/detail`, query: { action: 'create', storeId: this.queryParams.storeId }})
    },
    handleApprove(row) {
      this.isApprove = true
      this.selectedStoreId = row.shopId
      this.selectedGoodsId = row.id
      this.dialogTitle = '商品审核'
      this.dialogVisible = true
    },
    onApproved(status) {
      const approveData = {
        isOnsale: status,
        id: this.selectedGoodsId,
        referred: this.approveMessage
      }
      this.approveLoading = true
      approveGoods(approveData).then(() => {
        this.approveMessage = ''
        this.$message.success('审核完成')
        this.$util.delay().then(() => {
          const item = this.list.filter(value => value.id === this.selectedGoodsId)
          if (item && item.length) {
            item[0].reason = approveData.referred
            item[0].status = status
          }
          this.dialogVisible = false
        })
      }).catch(() => {
        this.$message.error('提交审核数据失败')
      }).finally(() => {
        this.approveLoading = false
      })
    },
    handleOnsale(row) {
      this.isApprove = false
      this.putOnsale = true
      this.selectedStoreId = row.shopId
      this.selectedGoodsId = row.id
      this.dialogTitle = '商品上架'
      this.dialogVisible = true
    },
    handleDelist(row) {
      this.isApprove = false
      this.putOnsale = false
      this.selectedStoreId = row.shopId
      this.selectedGoodsId = row.id
      this.dialogTitle = '商品下架'
      this.dialogVisible = true
    },
    onSale(status) {
      const saleData = {
        id: this.selectedGoodsId,
        isOnsale: status
      }
      this.approveLoading = true
      putGoodOnsale(saleData).then(() => {
        this.approveMessage = ''
        return this.$util.delay()
      }).then(() => {
        const item = this.list.filter(value => value.id === this.selectedGoodsId)
        if (item && item.length) item[0].isOnsale = status

        this.dialogVisible = false
      }).catch(() => {
        this.$message.error(`商品${status === 1 ? '上架' : '下架'}失败`)
      }).finally(() => {
        this.approveLoading = false
      })
    },
    handleEdit(row) {
      const query = {
        action: 'edit',
        from: this.queryParams.storeId ? '' : 'store',
        storeId: `${row.shopId}`,
        id: `${row.id}`
      }
      this.$router.push({ path: `/store/goods/detail`, query })
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-tag {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  .el-tag {
    display: block;
    width: 100%;
    + .el-tag {
      margin-top: 8px;
    }
  }
}
.flex-switch {
  display: flex;
  align-items: center;
  justify-content: center;
  + .flex-switch {
    margin-top: 5px;
  }
}
::v-deep {
  .el-card__header {
    padding-bottom: 0;
  }
}
.tool-tip-icon {
  margin-left: 5px;
  font-size: 14px;
  color: #E6A23C;
  font-weight: 600;
  cursor: default;
}
</style>
